<template>
	<v-card v-if="producto">
		<v-card-title class="headline">Movimiento de inventario de «{{ producto.descripción }}»</v-card-title>

		<v-card-text>

			<v-radio-group v-model="datos.tipo">
				<template v-slot:label>
					<div>¿Desea agregar o retirar unidades del inventario?</div>
				</template>
				<v-radio value="entrada" color="success">
					<template v-slot:label>
						<div>
							<v-icon :class="{'success--text': datos.tipo === 'entrada'}">mdi-playlist-plus</v-icon>
							&nbsp;
							<strong :class="{'success--text': datos.tipo === 'entrada'}">Agregar al inventario</strong>
						</div>
					</template>
				</v-radio>
				<v-radio value="salida" color="error">
					<template v-slot:label>
						<div>
							<v-icon :class="{'error--text': datos.tipo === 'salida'}">mdi-playlist-minus</v-icon>
							&nbsp;
							<strong :class="{'error--text': datos.tipo === 'salida'}">Retirar del inventario</strong>
						</div>
					</template>
				</v-radio>
			</v-radio-group>

			<br>

			<v-text-field
				v-if="datos.tipo === 'entrada' || datos.tipo === 'salida'"
				v-model="datos.cantidad"
				:label="`Cantidad a ${datos.tipo === 'entrada' ? 'agregar al': 'retirar del'} inventario`"
				type="number"
				min="1"
				max="10000"
				step="1"
				outlined
			></v-text-field>

			<v-textarea
				v-if="datos.tipo === 'entrada' || datos.tipo === 'salida'"
				v-model="datos.motivo"
				:label="`¿Por qué está ${datos.tipo === 'entrada' ? 'agregando': 'retirando'} unidades del inventario?`"
				rows="3"
				outlined
			></v-textarea>

		</v-card-text>

		<v-card-actions>
			<v-spacer></v-spacer>

			<v-btn
				color="grey darken-1"
				text
				:disabled="fuente.guardandoInventario"
				@click="cancelar"
			>
				Cancelar
			</v-btn>

			<v-btn
				color="blue darken-1"
				text
				:loading="fuente.guardandoInventario"
				@click="guardar"
			>
				Guardar
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import { productos } from '@/../../cliente_comun/fuentes'

export default {
	name: 'ajustes-de-inventario-de-producto',
  data: () => ({
		fuente: productos,
		datos: {
			tipo: '',
			cantidad: '',
			motivo: '',
		},
	}),
	props: ['producto'],
	methods: {
		guardar: function() {
			this.fuente.guardarMovimientoDeInventario(this.producto.identificador, this.datos).then( () => {
				this.limpiar()
				this.$emit('guardar', true)
			})
		},
		cancelar: function() {
			this.limpiar()
			this.$emit('cancelar', true)
		},
		limpiar: function() {
			this.datos.tipo = ''
			this.datos.cantidad = ''
			this.datos.motivo = ''
		},
	}
}
</script>
